export const BILLING_APP_CODES = Object.freeze({
  CHIT_FUND: 'CHIT_FUND',
  DAILY_COLLECTION: 'DAILY_COLLECTION',
  VEHICLE_FINANCE: 'VEHICLE_FINANCE',
  PERSONAL_LOAN: 'PERSONAL_LOAN',
  PERSONAL_FINANCE: 'PERSONAL_FINANCE',
  RENTAL_MANAGEMENT: 'RENTAL_MANAGEMENT',
  HOSTEL_MANAGEMENT: 'HOSTEL_MANAGEMENT',
  MUTTON_STALL: 'MUTTON_STALL',
  HOSPITAL_MANAGEMENT: 'HOSPITAL_MANAGEMENT',
  DOCUMENTS: 'DOCUMENTS',
  VEHICLE_PARKING: 'VEHICLE_PARKING',
  DEEPAVALI_CHITS: 'DEEPAVALI_CHITS',
});

export const DEFAULT_BILLING_APP_CODE = BILLING_APP_CODES.CHIT_FUND;

export const BILLING_PATHS = Object.freeze({
  CHIT_FUND: '/chit-fund/user/billing',
  DAILY_COLLECTION: '/daily-collection/user/billing',
  VEHICLE_FINANCE: '/vehicle-finance/user/billing',
  PERSONAL_LOAN: '/personal-loan/user/billing',
  PERSONAL_FINANCE: '/personal-finance/user/billing',
  RENTAL_MANAGEMENT: '/rental-management/user/billing',
  HOSTEL_MANAGEMENT: '/hostel-management/user/billing',
  MUTTON_STALL: '/mutton-stall/user/billing',
  HOSPITAL_MANAGEMENT: '/hospital-management/user/billing',
  DOCUMENTS: '/documents-box/user/billing',
  VEHICLE_PARKING: '/vehicle-parking/user/billing',
  DEEPAVALI_CHITS: '/deepavali-chits/user/billing',
});

export const getBillingPathForApp = (appCode) =>
  BILLING_PATHS[appCode] || BILLING_PATHS.CHIT_FUND;

export const normalizeBillingAppCode = (value) => {
  if (value == null || value === '') return DEFAULT_BILLING_APP_CODE;
  const normalized = String(value).trim().toUpperCase();
  return Object.values(BILLING_APP_CODES).includes(normalized)
    ? normalized
    : DEFAULT_BILLING_APP_CODE;
};
